/* Global theme behaviour: drawers, cart (Shopify AJAX Cart API + Section Rendering), reveal motion. */
(function () {
  'use strict';
  var T = window.theme || {};
  var routes = T.routes || {};
  var S = T.strings || {};

  /* ---------------- Toast ---------------- */
  var toastTimer;
  function toast(msg, isError) {
    var el = document.querySelector('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('toast--error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ---------------- Drawers ---------------- */
  var lastFocus = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    document.querySelectorAll('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = drawer.querySelector('.drawer__panel');
    var first = panel && panel.querySelector(FOCUSABLE);
    setTimeout(function () { if (first) first.focus(); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    document.querySelectorAll('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen)); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('[data-drawer]')); return; }
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && T.cartType === 'drawer' && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openDrawer(document.getElementById('CartDrawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    var open = document.querySelector('[data-drawer].is-open');
    if (!open) return;
    if (e.key === 'Escape') { closeDrawer(open); return; }
    if (e.key === 'Tab') {
      var items = Array.prototype.slice.call(open.querySelectorAll('.drawer__panel ' + FOCUSABLE)).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- Quantity steppers (product forms) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var input = btn.closest('[data-qty]').querySelector('[data-qty-input]');
    var val = parseInt(input.value, 10) || 1;
    val = btn.hasAttribute('data-qty-plus') ? val + 1 : val - 1;
    input.value = Math.min(Number(input.max) || 10, Math.max(Number(input.min) || 1, val));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Cart ---------------- */
  function cartPageSectionId() {
    var page = document.querySelector('[data-cart-page]');
    var wrap = page && page.closest('.shopify-section');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }
  function sectionsToRender() {
    var ids = ['cart-drawer'];
    var page = cartPageSectionId();
    if (page) ids.push(page);
    return ids;
  }

  function parseError(res, data) {
    var msg = (data && (data.description || data.message)) || S.genericError;
    if (typeof msg !== 'string') msg = S.genericError;
    var err = new Error(msg);
    err.status = res.status;
    return err;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok || data.status) throw parseError(res, data);
        return data;
      });
    });
  }

  function renderSections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = parser.parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        var drawer = document.getElementById('CartDrawer');
        if (!drawer) return;
        ['[data-cart-region]', '[data-cart-foot]', '[data-cart-count-label]'].forEach(function (sel) {
          var from = doc.querySelector(sel), to = drawer.querySelector(sel);
          if (from && to) { to.innerHTML = from.innerHTML; to.hidden = from.hidden; }
        });
      } else {
        var wrap = document.getElementById('shopify-section-' + id);
        var fresh = doc.querySelector('.shopify-section') || doc.body;
        if (wrap && fresh) wrap.innerHTML = fresh.innerHTML;
      }
    });
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function refreshCount() {
    return fetch(routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }

  function showCartError(msg) {
    document.querySelectorAll('[data-cart-error]').forEach(function (el) {
      el.textContent = msg; el.hidden = !msg;
    });
  }

  var Cart = {
    /** items: [{ id, quantity, properties? }] — always validated by Shopify server-side */
    add: function (items) {
      var clean = (items || []).filter(function (i) {
        return i && Number(i.id) > 0 && Number(i.quantity) >= 1 && Number(i.quantity) <= 10;
      });
      if (!clean.length) return Promise.reject(new Error(S.genericError));
      return post(routes.cartAdd + '.js', { items: clean, sections: sectionsToRender(), sections_url: window.location.pathname })
        .then(function (data) {
          if (T.cartType === 'page') { window.location.href = routes.cart; return data; }
          renderSections(data.sections);
          return refreshCount().then(function () {
            openDrawer(document.getElementById('CartDrawer'));
            toast(S.added);
            return data;
          });
        });
    },
    change: function (line, quantity) {
      var regions = document.querySelectorAll('[data-cart-region], [data-cart-foot]');
      regions.forEach(function (r) { r.setAttribute('data-cart-busy', ''); });
      showCartError('');
      return post(routes.cartChange + '.js', { line: line, quantity: quantity, sections: sectionsToRender(), sections_url: window.location.pathname })
        .then(function (cart) {
          renderSections(cart.sections);
          updateCount(cart.item_count);
          return cart;
        })
        .catch(function (err) {
          showCartError(err.message || S.genericError);
          toast(err.message || S.genericError, true);
        })
        .finally(function () {
          document.querySelectorAll('[data-cart-busy]').forEach(function (r) { r.removeAttribute('data-cart-busy'); });
        });
    }
  };
  window.Cart = Cart;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    var qty = Math.max(0, Math.min(10, parseInt(btn.dataset.cartQty, 10) || 0));
    Cart.change(parseInt(btn.dataset.cartLine, 10), qty);
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line-input]');
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    if (qty > 10) qty = 10;
    Cart.change(parseInt(input.dataset.cartLineInput, 10), qty);
  });

  // Keep the badge right when the visitor comes back via the browser's back button
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });

  /* ---------------- Reveal on scroll ---------------- */
  if (document.documentElement.classList.contains('js-anim') && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    var observe = function () { document.querySelectorAll('.reveal:not(.is-in)').forEach(function (el) { io.observe(el); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe); else observe();
    document.addEventListener('shopify:section:load', observe);
  } else {
    document.documentElement.classList.remove('js-anim');
  }

  /* ---------------- Recently viewed ---------------- */
  function initRecent() {
    document.querySelectorAll('[data-recently-viewed]').forEach(function (wrap) {
      var current = wrap.dataset.current || '';
      var limit = Number(wrap.dataset.limit) || 4;
      var handles = [];
      try { handles = JSON.parse(localStorage.getItem('recently_viewed') || '[]'); } catch (e) {}
      handles = handles.filter(function (h) { return h && h !== current; }).slice(0, limit);
      if (!handles.length) return;
      var grid = wrap.querySelector('[data-recent-grid]');
      Promise.all(handles.map(function (h) {
        return fetch(routes.root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;
        grid.innerHTML = products.map(function (p) {
          var tags = p.tags || [];
          var box = tags.indexOf('women') > -1 ? wrap.dataset.boxWomen : tags.indexOf('couples') > -1 ? wrap.dataset.boxCouples : (tags.indexOf('mystery-pack') > -1 || tags.indexOf('men') > -1) ? wrap.dataset.boxMen : '';
          var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="" loading="lazy" width="600" height="750">' : (box ? '<img class="card__box-img" src="' + box + '" alt="" loading="lazy" width="1024" height="1536">' : '');
          var price = window.MysteryCore ? window.MysteryCore.formatMoney(p.price_min, T.moneyFormat) : '';
          var safeTitle = String(p.title).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
          return '<div class="card"><div class="card__media media media--portrait">' + img + '</div>' +
            '<h3 class="card__title"><a href="' + p.url + '">' + safeTitle + '</a></h3>' +
            '<div class="card__meta"><span>' + price + '</span></div></div>';
        }).join('');
        wrap.hidden = false;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRecent); else initRecent();

  window.themeToast = toast;
})();
